import {
  Lit3formBlock,
  html,
  unsafeHTML,
  ifDefined,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';

import {
  analyticsCtaDataObject,
  handleAdobeNavEvent,
  adobeCleanString,
} from '../../../helpers/adobe-analytics';

import { vimeoIdFrom } from '@Helpers/vimeo-video';

export class Tyler extends Lit3formBlock {
  static get characterName() {
    return 'tyler';
  }

  static get characterProperties() {
    return {
      cta: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid tyler-layout">
          ${this.subHeaderHTML} ${this.primaryTextHTML} ${this.descriptionHTML}
          ${this.ctaHTML}
          ${this.videoId
            ? html`
                <div class="video media">
                  <vimeo-video
                    videoid="${this.videoId}"
                    fitaspect
                  ></vimeo-video>
                </div>
              `
            : html`
                <div class="image media">
                  <a
                    href=${ifDefined(
                      this.hasCta ? this.content.cta.url : undefined
                    )}
                    @click="${event => this.handleImageClick(event)}"
                  >
                    <img src="${this.imageUrl}" />
                  </a>
                </div>
              `}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get subHeaderHTML() {
    return this.subHeaderText
      ? html`
          <p class="subheader">${unsafeHTML(this.subHeaderText)}</p>
        `
      : ``;
  }

  get primaryTextHTML() {
    return this.primaryText
      ? html`
          <div class="primary-text details-row">
            <h2>${unsafeHTML(this.primaryText)}</h2>
          </div>
        `
      : ``;
  }

  get descriptionHTML() {
    return this.descriptionText
      ? html`
          <p class="description details-row">
            ${unsafeHTML(this.descriptionText)}
          </p>
        `
      : ``;
  }

  get ctaHTML() {
    return this.hasCta
      ? html`
          <cta-button
            class="cta-btn"
            cta-data=${this.ctaInfo}
            cta-type="primary"
            .ctaAnalyticsData=${analyticsCtaDataObject(
              this.ctaInfo,
              this.primaryText
            )}
          ></cta-button>
        `
      : ``;
  }

  get ctaInfo() {
    const cta = this.content.cta || {};
    // external links need to open in a new tab
    if (!cta.url.includes('3-form')) {
      cta.target = '_blank';
    }
    return JSON.stringify(this.content.cta);
  }

  get hasCta() {
    return this.content.cta && !!this.content.cta.text;
  }

  handleImageClick(event) {
    if (!this.hasCta) return;
    handleAdobeNavEvent({
      navString: `NAV|Image Driver|${adobeCleanString(this.content.cta.text)}`,
      destinationUrl: this.content.cta.url,
      event,
    });
  }

  get primaryText() {
    return this.withLineBreaks(this.content.primary_text) || '';
  }

  get subHeaderText() {
    return this.withLineBreaks(this.content.sub_header) || '';
  }

  get videoId() {
    return vimeoIdFrom(this.content.video_url);
  }

  get imageUrl() {
    return !!this.content.image
      ? this.imagebossUrl(this.content.image.src, null, 1500)
      : '';
  }
}
Tyler.defineElement();
